import React, { useEffect } from "react";
import Modal from "react-modal";
import * as actionTypes from "@redux/actionTypes";
import { useSelector, useDispatch } from "react-redux";
import NoTestBot from "@components/Modal/NoTestBot";
import { useAuth } from "@context";
import RPC from "@components/SolanaWallet/solanaRPC";
import { safeLocalStorage } from '@utils/localstorage';
import TestDriveHeader from "./TestDriveHeader";
import HowToPlayGuidence from "./HowToPlayGuidence";
import TestDriveButton from "./TestDriveButton";

const BotTestDrive = () => {
  const dispatch = useDispatch();
  const { setAccountInfo, setWalletAddress, provider, loginFlag } = useAuth();
  const token = safeLocalStorage.getItem("token")
  const noTestDriveModel = useSelector((state) => state.loadingSpinner.noTestDriveModel);

  useEffect(() => {
    if (!token) {
      if (loginFlag) {
        getAccounts()
      }
    }
  }, [loginFlag, token]);

  const getAccounts = async () => {
    const rpc = new RPC(provider);
    const walletAddress = await rpc.getAccounts();
    if (walletAddress.length > 0) {
      setWalletAddress(walletAddress[0])
      setAccountInfo(walletAddress[0])
    }
  };

  const closeNoTestBotModel = () => {
    dispatch({
      type: actionTypes.NO_TESTDRIVE_BOT,
      payload: false,
    });
  }

  return (
    <div className="bot-main-sections">
      <div className="test-drive-data">
        {token && <TestDriveHeader />}
      </div>
      <HowToPlayGuidence />
      <TestDriveButton />
      <Modal
        isOpen={noTestDriveModel}
        className="mymodal"
        ariaHideApp={false}
        onRequestClose={closeNoTestBotModel}
      >
        <NoTestBot closeNoTestBotModel={closeNoTestBotModel} />
      </Modal>
    </div>
  )
};

export default BotTestDrive;